export default __webpack_public_path__ + "static/media/golive_white.703d29cb.png";